import { render, staticRenderFns } from "./TestViolatePopup.vue?vue&type=template&id=8fad1368&scoped=true&"
import script from "./TestViolatePopup.vue?vue&type=script&lang=js&"
export * from "./TestViolatePopup.vue?vue&type=script&lang=js&"
import style0 from "./TestViolatePopup.vue?vue&type=style&index=0&id=8fad1368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fad1368",
  null
  
)

export default component.exports